import { os } from '@repo/common-utils';
import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';

import Layout from '@/components/layout/Layout';
import { useRightInquiryTextButton } from '@/components/tax-refund/common/hooks/use-create-header-props';
import CorporationSelectAuthContent from '@/components/tax-refund/corporation/SelectAuth/CorporationSelectAuthContent';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const CorporationSelectAuthPage = () => {
  const rightInquiryButton = useRightInquiryTextButton(SUPPORT_BOT_LINK.인증타입선택, 'corps-selectauth_cx_top-right');

  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'corps-selectauth'} eventProperty={{ type: os.is('Windows') ? 'windows' : 'no-window' }}>
        <Layout leftIcon={{ icon: 'back', clickEvent: { name: 'corps-selectauth_topnav_back' } }} rightTextButton={rightInquiryButton}>
          <CorporationSelectAuthContent />
        </Layout>
      </PageViewEventLogger>
    </AuthGuard>
  );
};

export default CorporationSelectAuthPage;
